/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR as ɵa,SwitchComponent as ɵb} from './lib/nb-widgets/switch/switch.component';